"use strict";var r=require("styled-components").css`
    margin: 0 ${({theme:r})=>r.spacing.large};
    display: grid;
    grid-row-gap: 40px;
    background: ${({theme:r})=>r.colors.primary.dark};
    color: white;
    .inner {
        width: 100%;
        max-width: ${({theme:r})=>r.widths.small};
        margin: auto;
        display: grid;
        grid-row-gap: 40px;
        padding: 50px ${({theme:r})=>r.spacing.large};
        box-sizing: border-box;
        border-radius: 5px;

        @media (min-width: ${({theme:r})=>r.breakpoints.large}) {
            max-width: ${({theme:r})=>r.widths.large};
            grid-row-gap: 46px;
            padding: 76px ${({theme:r})=>r.spacing.large} 114px;
        }
    }

    header {
        text-align: center;
        display: grid;
        grid-row-gap: 10px;
        margin: auto;

        h2 {
            color: currentColor;
            margin: 0;
        }

        p {
            color: currentColor;
            margin: 0;
        }
    }

    .brands {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: calc(100% + 28px);
        margin: -5px -14px;
        list-style: none;
        padding: 0;
        align-items: center;
        justify-content: center;

        .brands--img-container {
            aspect-ratio: 2 / 1;
            width: calc(50% - 28px);
            max-width: 200px;
            margin: 5px 14px;
            color: currentColor;

            img {
                width: 100%;
            }
        }
    }
`;module.exports=r;
//# sourceMappingURL=styles.js.map
